function Approach() {
  return (
    <section className="approach" id="approach">
      <div className="wrap">
        <div className="section-head">
          <div className="eyebrow">Our approach</div>
          <h2>Insight before placement.</h2>
          <p>We start with the client’s business—not a predefined product. By understanding exposures, objectives and operating context, we shape a suitable programme, engage the right markets and remain involved beyond placement.</p>
        </div>
        <div className="steps">
          <div className="step" data-label="01"><span>01</span><strong>Understand</strong><b>→</b></div>
          <div className="step" data-label="02"><span>02</span><strong>Structure</strong><b>→</b></div>
          <div className="step" data-label="03"><span>03</span><strong>Connect</strong><b>→</b></div>
          <div className="step" data-label="04"><span>04</span><strong>Support</strong><b>→</b></div>
        </div>
      </div>
    </section>
  )
}

export default Approach
